import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {YsoProduct} from '../../../../data/model';

@Component({
  selector: 'app-yso-product-info',
  templateUrl: './yso-product-info.component.html',
  styleUrls: ['./yso-product-info.component.scss'],
  host: {class: 'app-yso-product-info'},
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class YsoProductInfoComponent {
  @Input() product: YsoProduct;
}
